import aboutImage from "./about-og-image.png";
export default function About() {
  return (
    <section id="about" className="section">
      <h2>About Us</h2>
      <div className="about-content">
        <div className="about-text">
          <p>
            Circle Connect is a Jordan-based company
            established in 2023, specializing in sustainable
            digital communication solutions.
            We provide innovative NFC-powered smart
            products that redefine the way individuals and
            businesses exchange information.
            Our mission is to merge cutting-edge technology with
            environmental responsibility, reducing paper waste while
            promoting eco-friendly alternatives.
          </p>
        </div>
        <div className="about-image">
          <img
            src={aboutImage}
            alt="Our team working together"
            style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "var(--radius)" }}
          />
        </div>
      </div>
    </section>
  )
}
